import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { throwError } from 'rxjs';

import { DateValidator } from '@unico-people/shared/utils/validators/utils-date-validator';
import { EmployeesService } from '../../../services/employees/employees.service';

@Component({
  selector: 'app-form-infos-add-colab',
  templateUrl: './infos-add-colab.component.html',
  styleUrls: ['./infos-add-colab.component.scss']
})
export class InfosAddColabUpdateComponent implements OnInit {
  admissionDate: string;
  formInfosAddColaborador: FormGroup;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  submittingForm: boolean;

  @Input() colaboradorRef: any;

  @Input() infos: any;
  @Output() reload: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private fb: FormBuilder, private employeesService: EmployeesService) {}

  ngOnInit(): void {
    this.createForm();
    this.loadInfos();
  }

  createForm(): void {
    this.formInfosAddColaborador = this.fb.group({
      date: [this.infos?.admission.date, [Validators.required, DateValidator.brazilianDate, DateValidator.pastDate]],
      employeeCode: [this.infos?.employeeCode],
      leaderName: [this.infos?.admission?.leaderName],
      leaderEmail: [this.infos?.admission?.leaderEmail]
    });
  }

  loadInfos(): void {
    if (this.infos !== null && typeof this.infos !== 'undefined') {
      const dateAdmission = this.infos?.admission?.date ? new Date(this.infos?.admission?.date).toLocaleDateString('pt-BR') : undefined;

      this.formInfosAddColaborador.get('date').setValue(dateAdmission  || '');
      this.formInfosAddColaborador.get('employeeCode').setValue(this.infos?.employeeCode || '');
      this.formInfosAddColaborador.get('leaderName').setValue(this.infos?.admission?.leaderName  || '');
      this.formInfosAddColaborador.get('leaderEmail').setValue(this.infos?.admission?.leaderEmail  || '');
    }
  }

  submitForm(form: FormGroup): void {
    const formValue = form.value;
    const dateValue = formValue.date ? formValue.date.split('/').reverse().join('-') : undefined;
    this.submittingForm = true;

    const data = {
      id: this.infos?.id,
      name: this.infos?.name,
      email: this.infos?.email,
      birthDate: this.infos?.birthDate,
      role: null,
      department: null,
      unit: null,
      employeeCode: formValue?.employeeCode,
      admission: {
        id: this.infos?.admission?.id,
        organizationID: this.infos?.admission?.organizationID,
        date: dateValue ? new Date(dateValue).toISOString() : undefined,
        leaderName: formValue?.leaderName,
        leaderEmail: formValue?.leaderEmail
      }
    };

    this.employeesService.updateEmployee(data).subscribe(
      () => (this.reload.emit(true), (this.submittingForm = false)),
      err => (this.reload.emit(true), throwError(err))
    );
  }

  /**
   * Cancel form editing action by reseting form, loading the original information and closing the edition view
   */
  cancel($event: Event): void {
    this.formInfosAddColaborador.reset();
    this.loadInfos();
    this.colaboradorRef.deactiveEdit($event);
  }
}
